var React = require('react');

function FacebookRedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.5002 16C31.5002 7.4375 24.5627 0.5 16.0002 0.5C7.43774 0.5 0.500244 7.4375 0.500244 16C0.500244 23.75 6.12524 30.1875 13.5627 31.3125V20.5H9.62524V16H13.5627V12.625C13.5627 8.75 15.8752 6.5625 19.3752 6.5625C21.1252 6.5625 22.8752 6.875 22.8752 6.875V10.6875H20.9377C19.0002 10.6875 18.3752 11.875 18.3752 13.125V16H22.6877L22.0002 20.5H18.3752V31.3125C25.8127 30.1875 31.5002 23.75 31.5002 16Z","fill":"#C8102E"}));
}

FacebookRedInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = FacebookRedInline;

FacebookRedInline.default = FacebookRedInline;
